import nanoid from "nanoid";
import api, { handleError } from "../index";

export const storePageviewVariant = async (payload) => {
  try {
    const response = await api({
      method: "post",
      url: "/pageview-variants",
      data: {
        pageview_guid: payload.pageview_guid || nanoid(),
        variant_id: payload.variant_id,
        variant_name: payload.variant_name,
        coupon: payload.coupon,
      },
    });
    return { error: null, data: response.data };
  } catch (error) {
    const errorPayload = handleError(error);
    return {
      ...errorPayload,
      data: null,
    };
  }
};
